import React, { useContext, useState } from 'react';
import { OrdersContext } from '../context/orders.context';
import { processType } from '../utils/constant';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { ChatRefContext } from '../context/chatRef.context';
import Chat from './Chat';
import ChatButton from './Chat/ChatButton';
import qs from 'query-string';
import CurrencyFormat from './CurrencyFormat';
import tickImage from '../assets/tick.svg';
import closeImage from '../assets/close.svg';

const OrderTable = ({orderData}) => {
    const {
        activeTab,
     } = useContext(OrdersContext);
     const {selectedChatRefId,setSelectedChatRefId} = useContext(ChatRefContext);

     const showDrawer = (id) => {
        setOpen(id);

        let userId = localStorage.getItem('_id');
        let email = localStorage.getItem('email');
        if (window.location.host === 'sc.dainsta.com') {
            window?.dataLayer?.push({
            event: 'chatOpen',
            userId: userId,
            chatRefId: id,
            referenceId: email?.split('@')[0]+ email?.split('@')[1]?.split(".")[0],
            })
        }
        setSelectedChatRefId(id)
    };

    const onClose = () => {
        setOpen(false);
        setSelectedChatRefId(null)
    };

    const { search, } = window.location;
    const param = qs.parse(search);
    const [open, setOpen] = useState(param.RefId);
    
     const navigate = useNavigate();

     const handleOrderDetails = (orderId) =>{
        navigate(`/order-details/${orderId}`)
     }


     return (
        <div className='relative overflow-x-auto w-full'>
            <Chat RefId={selectedChatRefId} open={selectedChatRefId === open && selectedChatRefId.length>0} onDrawerClose={onClose} />
           <table className=' text-xs text-gray-700 uppercase bg-gray-50 w-full '>
                <thead>
                    <tr>
                        <th scope='col' className='px-6 py-2 ' >ORDER ID</th>
                        <th scope='col' className='px-6 py-2'>PROJECT NAME</th>
                        <th scope='col' className='px-6 py-2'>TYPE OF MFG. PROCESS</th>
                        <th scope='col' className='px-6 py-2'>REQUEST DATE</th>
                        <th scope='col' className='px-6 py-2'>PSD</th>
                        <th scope='col' className='px-6 py-2'>ESD</th>
                        {activeTab!='active-orders'?<th scope='col' className='px-6 py-2'>ASD</th>:<></>}
                        {activeTab=='active-orders'?<th scope='col' className='px-6 py-2'>QR</th>:<></>}
                        {activeTab=='closed-orders' || activeTab=='delivered-orders'?<><th>DELIVERY DATE</th></>:<></> }
                        <th scope='col' className='px-6 py-2'>STATUS</th>
                        <th scope='col' className='px-6 py-2'>ORDER VALUE</th>
                        <th scope='col' className='px-6 py-2'>PO NO.</th>
                        <th scope='col' className='px-6 py-2'>CHAT</th>
                        {/* <th scope='col' className='px-6 py-2'>ACTION</th> */}
                    </tr>
                </thead>
                <tbody className='order-body'>
                   {orderData.length>0 &&  orderData.map((item,i)=>{
                    return(
                        <tr key={i} className='bg-white border-b'>
                            <td className='px-6 py-2 font-medium underline whitespace-nowrap text-primaryColor cursor-pointer' onClick={()=> handleOrderDetails(item.pORefId)}>{item?.pORefId}</td>
                            <td className='px-6 py-2  max-w-32 whitespace-normal break-words'>{item.rfqs.projectName}</td>
                            <td className='px-6 py-2 '>{processType[item?.rfqs.selectedProcess-1]?.name}</td>
                            <td className='px-6 py-2  whitespace-nowrap'>{moment(item.createdAt).format("DD MMM YYYY")}</td>
                            <td className='px-6 py-2  whitespace-nowrap'>
                                {item?.poAcceptanceDate?
                                <>
                                    {moment(item?.poAcceptanceDate).add(item?.supplierRFQId?.leadTime, "days").format("DD MMM YYYY")}
                                </>
                                :
                                <>
                                    {moment(Date.now()).add(item?.supplierRFQId?.leadTime, "days").format("DD MMM YYYY")}
                                </>
                                }
                            </td>
                            <td className='px-6 py-2 whitespace-nowrap'>
                                {
                                    item?.expectedShippingDates?.length>0?
                                    <>
                                        {moment(item?.expectedShippingDates.reduce((maxObj, currentObj) => {
                                            if (currentObj.updatedDate > maxObj.updatedDate) {
                                                return currentObj;
                                            }
                                            return maxObj;
                                            }).updateValue).format("DD MMM YYYY")
                                        }
                                    </>
                                    :
                                    <>
                                     {
                                     item?.poAcceptanceDate?
                                        <>
                                            {moment(item?.poAcceptanceDate).add(item?.supplierRFQId?.leadTime, "days").format("DD MMM YYYY")}
                                        </>
                                        :
                                        <>
                                            NA
                                        </>
                                    }
                                    </>
                                }
                            </td>
                            {activeTab!='active-orders'?<td className='px-6 py-2 whitespace-nowrap'>{item.shippedDate?moment(item.shippedDate).format("DD MMM YYYY"):'NA'}</td>:<></>}
                            {activeTab=='active-orders'?<td className='px-6 py-2'>{item?.supplierRFQId?.rfqId?.isQrTrackingRequested?<><img src={tickImage}/></>:<><img src={closeImage}/></>}</td>:<></>}
                            {activeTab=='closed-orders' || activeTab=='delivered-orders'?<><td>{item.deliveryDate? moment(item.createdAt).format("DD MMM YYYY") : "NA"}</td></>:<></> }
                            <td className='px-6 py-2 ' > <p className={activeTab=='closed-orders'?'closed-orders':activeTab=="billed-orders"?'Shipped':`${item.status.replaceAll(" ","_")}`}>{activeTab=="billed-orders"?"Shipped":item.status} </p></td>
                            <td className='px-6 py-2 min-w-max whitespace-nowrap'>€ {item?.totalAmount ?<CurrencyFormat amount = {Number(item?.totalAmount).toFixed(2)}/>:" NA" }</td>
                            <td className='px-6 py-2 '>{item?.purchaseOrderNumber?item?.purchaseOrderNumber:"NA"}</td>
                            <td className='px-6 py-1  my-1 flex items-center justify-start h-10' style={{textAlign:'center'}} > 
                                <button className="bg-primaryColor h-full  rounded flex items-center justify-start" onClick={() => showDrawer(item.pORefId)}>
                                    <ChatButton RefId={item.pORefId} color={'white'} showDrawer={() => showDrawer(item.pORefId)} additionalClasses={' text-white text-sm h-10'} />
                                </button>
                            </td>
                            </tr>
                    )
                   })
                   }
                </tbody>
            </table>
            {orderData.length==0?<div style={{textAlign:'center',fontSize:'14px',width:'100%',marginTop:'5px'}}>No Data Found </div>:<></>}
        </div>
    );
}

export default OrderTable;
